var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"construction_top flex flex_between"},[_c('div',[_c('button',{staticClass:"btn_error",on:{"click":function($event){return _vm.goAdd(`${_vm.is_role}_applyUrgent`, ['urgent', 'development'])}}},[_c('i',{staticClass:"el-icon-warning"}),_vm._v(" 申請緊急搶修 ")])])]),_c('UrgentList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }